import { useEffect } from 'react';
import { Links } from 'src/apis/api-utilities';
import {
  FinancialSecurity,
  RelationsParams,
} from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type HookConfig = {
  url?: string;
  params: RelationsParams;
};

type RequestOptions = {
  url: string;
  params: RelationsParams;
};

type ContractFinancialSecurityDetails = {
  _links: Links<'self' | 'first'>;
  limit: number;
  offset: number;
  total: number;
  _embedded: {
    items: FinancialSecurity[];
  };
};

export function useContractFinancialSecurities({ url, params }: HookConfig) {
  const financialSecurities = useAxios(
    (axios, signal, { url, params }: RequestOptions) =>
      axios.request<ContractFinancialSecurityDetails>({
        signal,
        url: urlTemplate.parse(url).expand({}),
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!url) return;
    financialSecurities.execute({ url, params });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, params]);

  if (!url) return;

  return financialSecurities;
}

export type ContractFinancialSecuritiesRequest = ReturnType<
  typeof useContractFinancialSecurities
>;
